import Icon from 'components/atoms/Icon';
import { PersonalityTestActionFragment } from 'generated/graphql';
import { FC, useState } from 'react';
import { Button, TextInputField } from '@spotted-zebra-uk/ui-components';
import EditPersonalityTestActionModal from './EditPersonalityTestActionModal';

interface IStagePersonalityTestAction {
  action: PersonalityTestActionFragment;
  projectId: number;
  disabled?: boolean;
}

const StagePersonalityTestAction: FC<IStagePersonalityTestAction> = ({
  action,
  projectId,
  disabled,
}) => {
  const [isConfigModalOpen, setIsConfigModalOpen] = useState(false);

  return (
    <div
      className="stage-test-action"
      data-testid="edit-project__stage-personality-test-action"
    >
      <Icon
        icon="personalityInCircleColored"
        className="stage-test-action__icon"
      />
      <TextInputField
        id={`personality-test-action-${action.id}`}
        disabled
        onChange={() => {}}
        value="Personality test"
        className="stage-test-action__name-label"
      />
      <Button
        variant="secondary"
        size="small"
        className="stage-test-action__config-button"
        data-testid="stage-personality-test-action__config-button"
        onClick={() => setIsConfigModalOpen(true)}
        disabled={disabled}
        aria-label="Configure personality test"
      >
        <Icon
          icon="settings"
          className="stage-test-action__config-button-icon"
        />
      </Button>
      {isConfigModalOpen && (
        <EditPersonalityTestActionModal
          action={action}
          projectId={projectId}
          onClose={() => setIsConfigModalOpen(false)}
        />
      )}
    </div>
  );
};

export default StagePersonalityTestAction;
